import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormLabel, Stack, TextField } from "@mui/material";
import { red } from "@mui/material/colors";
import { useState } from "react";
import { CreateTeacher } from "../FirebaseQueries";

interface Props {
	isOpen: boolean;
	onClose: () => void;
}

interface Result {
	id: string,
	email: string,
	message: string,
	success: boolean
}

export default function CreateTeacherUserDialog(props: Props) {
	const { isOpen, onClose } = props;

	const [fullName, setFullName] = useState("");
	const [email, setEmail] = useState("");

	const [fullNameError, setFullNameError] = useState("");
	const [emailError, setEmailError] = useState("");
	const [createError, setCreateError] = useState("");

	const [isCreating, setIsCreating] = useState(false);
	const redColour: string = red[600];

	function GetRandomPassword() {
		let passwordArray: string[] = [];
		const length = 6;

		const lowerCharsCount = randomInt(1, length - 2);
		const upperCharsCount = randomInt(1, length - lowerCharsCount - 1);
		const digitsCount = length - lowerCharsCount - upperCharsCount;

		const lowerChars = "abcdefghijklmnopqrstuvwxyz"
		const upperChars = lowerChars.toUpperCase();
		const digits = "0123456789";

		for (let i = 0; i < lowerCharsCount; i++) passwordArray.push(randomChar(lowerChars));
		for (let i = 0; i < upperCharsCount; i++) passwordArray.push(randomChar(upperChars));
		for (let i = 0; i < digitsCount; i++) passwordArray.push(randomChar(digits));

		passwordArray.sort(() => Math.random() - 0.5);
		return passwordArray.join("");
	}

	function randomInt(min: number, max: number) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	function randomChar(str: string) {
		return str[Math.floor(Math.random() * str.length)];
	}

	function HandleFullNameUpdate(event: any) {
		const value: string = event.target.value;
		setFullName(event.target.value);
		setFullNameError("");
	}

	function HandleEmailUpdate(event: any) {
		const value: string = event.target.value;
		setEmail(event.target.value);
		setEmailError("");
	}

	async function HandleOnCreate() {
		let hasError: boolean = false;
		setIsCreating(true);

		if (!/\S+@\S+\.\S+/.test(email)) {
			setEmailError("Please enter a valid email.");
			hasError = true;
		}

		if (fullName === "") {
			setFullNameError("Name must not be empty.");
			hasError = true;
		}

		if (hasError) {
			setIsCreating(false);
			return;
		}

		try {
			const res: Result = await CreateTeacher(email, GetRandomPassword(), fullName);
			if (res.success) {
				setIsCreating(false);
				onClose();
			}
			else {
				setCreateError(res.message);
				setIsCreating(false);
			}
		} catch (err) {
			setCreateError(String(err));
			setIsCreating(false);
		}
	}

	return (
		<Dialog onClose={onClose} open={isOpen}>
			<DialogTitle>Create Teacher User</DialogTitle>
			<DialogContent sx={{ minWidth: 500 }}>
				<Stack spacing={2}>
					<FormControl fullWidth>
						<FormLabel htmlFor="name">Name</FormLabel>
						<TextField
							id="name"
							value={fullName}
							placeholder=""
							variant="outlined"
							onChange={HandleFullNameUpdate}
							fullWidth
						>
						</TextField>
						<span style={{ color: redColour, minHeight: "22px" }}>{fullNameError}</span>
					</FormControl>
					<FormControl fullWidth>
						<FormLabel htmlFor="email">Email</FormLabel>
						<TextField
							id="email"
							value={email}
							placeholder="example@email.com"
							variant="outlined"
							onChange={HandleEmailUpdate}
							fullWidth
						>
						</TextField>
						<span style={{ color: redColour }}>{emailError}</span>
					</FormControl>
					<FormControl>
						<FormLabel>A password will be generated.</FormLabel>
					</FormControl>
					<span style={{ color: redColour }}>{createError}</span>
				</Stack>
			</DialogContent>
			<DialogActions>
				{/* <Button onClick={OnDelete} color="error" variant="contained">Delete</Button> */}
				<Button onClick={onClose}>Close</Button>
				<Button onClick={HandleOnCreate} loading={isCreating} variant="contained">Create</Button>
			</DialogActions>
		</Dialog>
	)
}